<template>
    <div class="m-module">
        <div class="section">
            <div class="page-title">
                <div class="text"> {{ $t("lang.withdrawCrypto") }}</div>
                <!-- <div class="text-field">转账USDT到数字币地址</div> -->
                <!-- Withdrawal -->
            </div>
            <div class="body">
                <div class="form-wrapper">
                    <div class="form-container">
                        <div class="form-item">
                            <div class="item-field">
                                <van-field :label="$t('lang.SendAddress')" :placeholder="$t('lang.SendAddress')" v-model="btAddrTo" :border="true"   @click-right-icon="handleRight"></van-field>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="item-field">
                                <van-field :label="$t('lang.Amount')" :placeholder="$t('lang.Amount')" v-model="btCoin" @input="changeAmount" >
                                    <template #button>
                                    <span class="unit">{{ $t("lang.minimunWithdrawal") }} {{onceMin}} </span>
                                    </template>
                                </van-field>
                            </div>
                            <!-- {{surplusRevoCoinAdvance}} -->
                            <div class="item-help">
                                <div class="text">{{ $t("lang.Balance") }} {{payment.surplusRevoCoinAdvance}} </div>
                                <div class="act" @click="Withdraw">{{ $t("lang.All") }}</div>
                            </div>
                        </div>
                         <div class="form-item">
                            <div class="item-label"></div>
                            <div class="item-help">
                                <div>{{ $t("lang.premium") }}</div>
                                <div>{{rateAmount.commission}} </div>
                            </div>
                        </div>
                    </div>
                </div>
                
              <div class="card">
                <div class="hd">
                    <h2 class="title">{{ $t("lang.WithdrawalHistory") }}</h2>
                </div>
                <div class="bd">
                    <div class="table-wrapper">
                      
                        <div   class="table-inner"     element-loading-spinner="el-icon-loading"  >
                            <el-table :data="dataSourceList">

                                <el-table-column  width="120" :label="$t('lang.amount')" prop="revoCoin" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.revoCoin }}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column  width="120" :label="$t('lang.premium')" prop="commission" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.commission }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="120" :label="$t('lang.amountReceived')" prop="btCoin" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.btCoin }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="120" :label="$t('lang.SendAddress')" prop="btAddrTo" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.btAddrTo }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="120" :label="$t('lang.arrived')" prop="tradeStateVal" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.tradeStateVal }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="190" :label="$t('lang.ReviewTime')"  prop="auditTime" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditTime }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="120" :label="$t('lang.ReviewStatus')" prop="auditStateVal" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditStateVal }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="120" :label="$t('lang.ProcessingStatus')" prop="processStateVal" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.processStateVal }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column  width="120" :label="$t('lang.ReasonRejection')" prop="auditReason" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditReason }}</span>
                                    </template>
                                </el-table-column>                             
                            </el-table>
                            <van-pagination v-model="current" :total-items="dataList.total" :items-per-page="dataList.size" @change="changeTab">
                                <template #prev-text>
                                <van-icon name="arrow-left" />
                                </template>
                                <template #next-text>
                                <van-icon name="arrow" />
                                </template>
                            </van-pagination>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="tabbar-placeholder"></div>
            <div class="tabbar">
                <div class="tabbar-inner u-flex">
                    <div class="total u-flex-3">
                        <div class="total-val">{{ $t("lang.amountReceived") }}
                        </div>
                        <span class="num">{{rateAmount.btCoin}} </span>
                    </div>
                    <div class="u-flex-2">
                        <van-button block round type="primary" @click="handShow">{{ $t("lang.withdraw") }}</van-button>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="coinPopup" position="bottom" closeable :style="{ height: '50%' }">
            <div class="popup-mod">
                <div class="hd">
                    <h3 class="title">Select Coin</h3>
                </div>
                <van-divider />
                <div class="bd">
                    <ul class="coins">
                        <li class="active">
                            <div class="coin">
                                <div class="item-icon">
                                    <img class="img" :src="require('@/assets/img/coins/USDT.svg')" />
                                </div>
                                <div class="item-info">
                                    <div class="item-title">USDT</div>
                                    <div class="item-desc">USDT</div>
                                </div>
                                <div class="item-status">
                                    <i class="icon el-icon-check"></i>
                                </div>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="coin">
                                <div class="item-icon">
                                    <img class="img" :src="require('@/assets/img/coins/BTC.svg')" />
                                </div>
                                <div class="item-info">
                                    <div class="item-title">BTC</div>
                                    <div class="item-desc">BTC</div>
                                </div>
                                <div class="item-status">
                                    <i class="icon el-icon-check"></i>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
                <div class="ft">
                    <div class="form-action">
                        <van-button round block type="primary">提交</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="networkPopup" position="bottom" closeable :style="{ height: '50%' }">
            <div class="popup-mod">
                <div class="hd">
                    <h3 class="title">{{ $t("lang.network") }}</h3>
                </div>
                <van-divider />
                <div class="bd">
                    <van-notice-bar wrapable left-icon="info-o">
                        {{ $t("lang.textRevolution") }}
                    </van-notice-bar>
                    <ul class="networks">
                        <li :class="{'active':item.active}" v-for="(item, index) in networkDataSources" :key="'net_'+index"
                            @click="selectNet(item, index)">
                            <div class="item">
                                <div class="item-info">
                                    <div class="item-title">{{item.networkName}}</div>
                                    <!-- <div class="item-desc">
                                        <div class="item-moment">预计到账时间 ≈ 0分钟</div>
                                        <div class="item-fee">手续费 1 TRX (≈ $0.09314)</div>
                                    </div> -->
                                </div>
                                <div class="item-status">
                                    <i class="icon el-icon-check"></i>
                                </div>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="item">
                                <div class="item-info">
                                    <div class="item-title">TRX <span class="extra">Tron(TRC20)</span></div>
                                    <div class="item-desc">
                                        <div class="item-moment">预计到账时间 ≈ 0分钟</div>
                                        <div class="item-fee">手续费 1 TRX (≈ $0.09314)</div>
                                    </div>
                                </div>
                                <div class="item-status">
                                    <i class="icon el-icon-check"></i>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
                <div class="ft">
                    <div class="form-action">
                        <van-button round block type="primary" @click="selectNetSubmit"> {{ $t("lang.submit") }}</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
        <el-dialog   :visible="showWord" :title='$t("lang.PasswordVerification")'  :close-on-click-modal="false"  width="85%" custom-class="mint-dialog"  @close="closeWord"  >
          <ul >
            <!-- <li><span>Title：</span>{{ item.title }}</li>
            <li><span>description:</span>{{ item.description }}</li> -->
            <li>
              <span>{{ $t("lang.Amount") }}:</span>
              <p>
                <img src="../../../assets/img/icon.png" alt="" />
                <span>{{ btCoin }} {{payment.btUnit}}</span>
              </p>
            </li>
          </ul>
          <el-input :placeholder="$t('lang.PleasePassword')" v-model="password" show-password></el-input>
          <div class="mint-Confirm">
            <el-button @click="hand()" :loading="btnLoadings" round   >{{$t("lang.submit")}}</el-button >
          </div>
        </el-dialog>
        <recharge-warning-dial ref="rechargeWarningDial" @close="closeWarn"></recharge-warning-dial>
    </div>
    </template>
    <script>
    import Header from "@/components/mobile/header";
    import lineChart from "@/views/account/modules/lineChart.vue";
    import { Dialog, Toast } from 'vant';
    import {axiosGet, axiosPost} from '@/api/api';
    import {BASE_GLOB_API} from "@/config.js";
    import EventBus from '@/utils/EventBus';
    import rechargeWarningDial from "@/components/rechargeWarningDial.vue";
    export default {
        name:'withdrawal-m',
        components: {
            Header,
            lineChart,
            rechargeWarningDial,
        },
        data(){
            return {
                coinPopup:false,
                networkPopup:false,
                form:{
                    verifyCode:''
                },
                stepActive:0,
                payment:{},
                btAddrTo:'',
                btCoin:'',
                natWork:'',
                networkDataSources:[],
                selectedNetData:{},
                rateAmount:{
                    commission:0,
                    rate:0,
                    btCoin:0,
                    gas:0
                },
                onceMin:0,
                url:{
                    coins:BASE_GLOB_API+'/kanban/coin/platform',
                    commissionRate:BASE_GLOB_API+'/withdrawal/commissionRate',
                    apply:BASE_GLOB_API+'/withdrawal/apply',
                    limit:BASE_GLOB_API+'//withdrawal/limit',
                    list:BASE_GLOB_API+'/withdrawal/page',
                },
                lang: "",
                btPlatformNetworkId:'',
                btPlatformName:'',
                showWord:false,
                password:'',
                isClick:true,
                btnLoadings:false,
                dataSourceList:[],
                current:1,
                dataList:{},
            }
        },
        created(){
            this.lang = sessionStorage.getItem("Language")
            let btFullList =JSON.parse(sessionStorage.getItem("btFull")) ;
            let selectedNet = JSON.parse( sessionStorage.getItem("selectedNet"));
            this.btPlatformNetworkId = selectedNet.btPlatformNetworkId
            this.btPlatformName = selectedNet.fullName
            if(btFullList){
                this.payment = btFullList
                // this.netWork()
                this.payLimit(this.payment)
                this.initList(1,6)
            }
            EventBus.$on('share', value => {
            // 将 A 组件传递过来的数据保存到 B 组件
                if(value){
                    let btFullList =JSON.parse(sessionStorage.getItem("btFull")) ;
                    let selectedNet = JSON.parse( sessionStorage.getItem("selectedNet"));
                    this.btPlatformNetworkId = selectedNet.btPlatformNetworkId
                    this.btPlatformName = selectedNet.fullName
                    if(btFullList){
                        this.payment = btFullList
                        // this.netWork()
                        this.payLimit(this.payment)
                        this.initList(1,6)
                    }
                }

            })
        },
        mounted(){
           
           
        },
        methods:{
            closeWarn(){
                this.showWord = true;
            },
            changeTab(e){
                console.log("e",e)
                this.initList(e,6)
            },
            initList(pageNo, pageSize){
                let params = {
                    current:pageNo||1,
                    size:pageSize||6,
                    query:{
                        btPlatformId: this.payment.btPlatformId
                    }
                }
                // params = Object.assign(params, this.queryParams);
                axiosPost(this.url.list, params).then(res=>{
                    if(res.success){
                        let data = res.result;
                        this.dataList = data
                        this.dataSourceList = data.records;
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            payLimit(e){
                let params = {
                    btPlatformId:e.btPlatformId,
                };
                axiosGet(this.url.limit, params).then(res=>{
                    if(res.success){
                      this.onceMin =res.result.onceMin
                    }else{
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.$message.error(err);
                   
                })
            },
            closeWord(){
                this.showWord =false
                this.password =""
            },
            handShow(){
                if(!this.btAddrTo){
                    this.$message.error(this.$t("lang.addressEmpty"));
                    return;
                 }
                const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
                if (!ethAddressRegex.test(this.btAddrTo)) {
                    this.$message.error(this.$t("lang.addressInvalid"));
                    return;
                }
                 if(!this.btCoin){
                    this.$message.error(this.$t("lang.withdrawalEmpty"));
                    return;
                 }
                 if(!this.payment.btPlatformId){
                    this.$message.error(this.$t("lang.platformEmpty"));
                    return;
                 }
                this.$refs.rechargeWarningDial.openDialog(this.btAddrTo, this.$t('lang.withdrawTo') + ":" + this.btPlatformName);
            },
            hand(){
                if(this.isClick) {
                this.isClick = false;
                console.log('我被点击了');
                this.handleNext();
                }else{
                console.log('请勿过快点击');
                }
            },
            handleNext(){
                if(!this.password){
                    this.$message.error(this.$t("lang.PleasePassword"));
                    setTimeout(()=>{ 
                            this.isClick = true;
                        },500)
                    return;
                 }
                this.btnLoadings = true;
                let params = {
                    btAddrTo:this.btAddrTo,
                    btCoin:this.btCoin,
                    btPlatformId:this.payment.btPlatformId,
                    btPlatformNetworkId:this.btPlatformNetworkId,
                    password:this.password
                };
                axiosPost(this.url.apply, params).then(res=>{
                    if(res.success){
                        this.btnLoadings = false;
                        setTimeout(()=>{ 
                            this.isClick = true;
                        },500)
                        this.closeWord()
                        this.btAddrTo=''
                        this.btCoin=''
                        this.$message.success(res.message);
                        this.$router.push({name:'dashboard-m'});
                    }else{
                        this.btnLoadings = false;
                        setTimeout(()=>{ 
                            this.isClick = true;
                        },500)
                        this.password =""
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.btnLoadings = false;
                    setTimeout(()=>{ 
                        this.isClick = true;
                    },500)
                    this.password =""
                    this.$message.error(err);
                   
                })
            },
            changeAmount(e){
                
                // console.log("22222",isNaN(e))
                // console.log("222111",!isNaN(e)&&e&& !(typeof e === 'string') && !(e.trim() === ''))
                if(!isNaN(e)&& !(e.trim() === '')){
                    let params = {
                      btCoin:e,
                      btPlatformId: this.payment.btPlatformId
                   };
                axiosPost(this.url.commissionRate, params).then(res=>{
                    if(res.success){
                      this.rateAmount.commission = res.result.commission
                      this.rateAmount.rate = res.result.rate
                      this.rateAmount.btCoin = res.result.btCoin
                      this.rateAmount.gas = res.result.gas
                    }else{
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.$message.error(err);
                   
                })
                }
            },
            selectNetSubmit(){
                if(this.selectedNetData){
                    this.natWork = this.selectedNetData.networkName
                    this.btPlatformNetworkId = this.selectedNetData.id
                    this.networkPopup =false
                }else{
                    this.networkPopup =false
                }
            },
            selectNet(obj, index){
                this.networkDataSources.forEach(item=>{
                    item.active = false;
                });
                obj.active = true;
                this.selectedNetData = obj;
                console.log("21",this.selectedNetData)
            },
            netWork(){
                axiosGet(this.url.coins).then(res=>{
                   if(res.code ==200){
                    let data =res.result,dataSource = [],networkDataSource = []
                    data.forEach(item=>{
                        if(item.networkVos){
                            item.networkVos.forEach(item=>{
                                let networkSource ={
                                    btPlatformId:item.btPlatformId,
                                    deletedVersion:item.deletedVersion,
                                    id:item.id,
                                    networkName:item.networkName,
                                    networkUrl:item.networkUrl,
                                    active:false
                               }
                               networkDataSource.push(networkSource);
                            });
                        }
                    });
                    this.networkDataSources = networkDataSource
                    console.log("2221",this.networkDataSources)
                   }
                }).catch(err=>{
                    console.log("coins catch:",err)
                })
            },
            Withdraw(){
               this.btCoin = this.payment.surplusRevoCoinAdvance
            },
            // handlePrev(){
            //     this.stepActive--;
            // },
            // handleNext(){
            //     this.stepActive++;
            // },
            handleCopy(content){
                this.$copyText(content).then(res=>{
                    Toast.success("复制成功")
                },
                err => {
                    Toast.fail("复制失败")
                })
            },
            handleRight(){
                console.log("handleRight")
            },
            showTips(){
                Dialog.alert({
                    message:"show tips信息",
                })
            }
        }
    }
    </script>
    <style lang="less" scoped>
    .m-module {
        .section {
            .page-title {
                font-size:20px;  padding:30px 15px;
                .text{
                    font-size:25px;font-weight:600;
                }
                .text-field{
                    font-size:14px;color: #999;
                }
            }
            .form-wrapper {
                background:#fff;
                .form-container {
                    padding:16px 0 0;
                    .form-item {
                        padding:0 0 10px;
                        
                        .item-label {
                            font-size:14px; color:#333; font-weight:600; padding:0 16px 2px;
                        }
                        .item-field {
                            &>.van-cell {
                                display:block;
                                ::v-deep .van-cell__title {
                                    font-weight:600; font-size:14px; color:#333; padding:0 0 4px; width:auto;
                                }
                                ::v-deep .van-cell__value {
                                    &:after {
                                        content:""; border-bottom:#ebedf0 1px solid; transform: scaleY(.5); position:absolute; left:0; right:0; bottom:-10px;
                                    }
                                }
                                
                            }
                            .input-amount {
                                ::v-deep .el-input__inner {border-right:0;}
                            }
                            ::v-deep .el-input-group__append {
                                background:transparent; border-left:#fff 1px solid;
                            }
                        }
                        .item-help {
                            display:flex; justify-content: space-between; align-items: center; padding:5px 16px 0;
                            .text {
                                color:#999; font-size:12px;
                            }
                            .act {
                                color:#4857f5; font-size:14px;
                            }
                        }
                        .item-view {
                            .van-cell-group {
                                .van-cell {
                                    padding:5px 16px;
                                    &:after {display:none;}
                                }
                            }
                            .help {
                                padding:4px 16px; font-size:12px; color:#999;
                            }
                        }
                    }
                }
            }
            .card {
                 padding: 30px 0;
            .hd {
                .title {}
            }
            .bd {
                .table-wrapper {
                    padding:10px 0;
                    .table-tools {
                        .table-tabs {
                            display:flex; justify-content: flex-start; align-items: center;
                            .tab-item {
                                line-height:1; padding:8px 14px; border-radius:4px; background:#f4f5f6; margin:0 10px 10px 0; cursor: pointer;
                                &.active, &:hover {
                                    background:#e7eafe; color:#4458fe;
                                }
                            }
                        }
                    }
                    .table-inner{
                        .pagination {
                            padding:15px 0; text-align:right;
                        }
                    }
                }
            }
        }
            .tittle{
                padding: 15px 10px;
                font-size: 18px;
                color: #000;
            }
            .tabTittle{
                display: flex;
                justify-content:space-around;
                height: 40px;
                background-color: #fff;
                line-height: 40px;
                font-size: 15px;
            }
            .list-wrapper {
                margin-top:1px;
                .item {
                    display:flex; justify-content: space-between; align-items: flex-start;
                    .item-icon {
                        width:36px; height:36px; min-width:36px;
                        .icon {
                            width:100%; height:100%;
                        }
                    }
                    .item-info {
                        padding:0 12px 0 6px; min-width:90px;
                        .item-title {
                            font-weight:600; font-size:16px;
                        }
                        .item-desc {
                            color:#999; font-size:12px; line-height:1.37;
                        }
                    }
                    .item-meta {
                        font-size:10px;  color:#666; flex:1; line-height:1.37;  display: flex;justify-content:space-around; align-items: flex-start; flex-wrap:wrap; text-align:center;
                        .meta {
                            width:15%; padding:0 5px 5px 0; box-sizing:border-box;
                            .meta-label {display:block;}
                            .meta-val {display:block; color:#333; font-weight:700;}
                        }
                    }
                }
            }
        }
    }
    .popup-mod {
        height:100%; position:relative; overflow: hidden;
        .hd {
            padding:16px 16px;
            .title {
                font-size:16px; font-weight:700;
            }
        }
        .van-divider {margin:0;}
        .bd {
            position:absolute; top:52px; left:0; right:0; bottom:54px; overflow:auto;
            .coins {
                padding:10px;
                &>li {
                    border-bottom:#e6e6e6 1px solid;
                    .coin {
                        display:flex; justify-content: space-between; align-items: center; padding:10px 15px;
                        .item-icon {
                            width:32px; height:32px; min-width:32px;
                            .img {width:100%; height:100%; border-radius:50%;}
                        }
                        .item-info {
                            padding:0 10px; flex:1; text-align:left;
                            .item-title {
                                font-weight:600; color:#333;
                            }
                            .item-desc {
                                color:#999; font-size:12px;
                            }
                        }
                        .item-status {
                            display:flex; justify-content: flex-end; align-items: center;
                            .icon {display:none;}
                        }
                    }
                    &.active {
                        .coin {
                            background:#e8eafc; color:#4857f5; border-radius:4px;
                            .item-status {
                                .icon {color:#44ac30; display:block;}
                            }
                        }
                    }
                }
            }
            .networks {
                &>li {
                    padding:3px 10px;
                    .item {
                         border-radius:4px; display:flex; justify-content: space-between; align-items: center; padding:10px;
                        .item-info {
                            flex:1; color:#333;
                            .item-title {
                                font-size:16px; font-weight:600;
                                .extra {font-size:14px; font-weight:normal; margin-left:6px;}
                            }
                            .item-desc {
                                opacity: .5; display:flex; justify-content: flex-start; align-items: center; font-size:14px;
                                .item-moment {margin-right:1em;}
                            }
                        }
                        .item-status {
                            display:flex; justify-content: center; align-items: center;
                            .icon {display:none;}
                        }
                    }
                    &.active {
                        .item {
                            background:#e8eafc; color:#4857f5;
                            .item-info {
                                color:#4857f5;
                            }
                            .item-status {
                                .icon {display:block;}
                            }
                        }
                    }
                }
            }
        }
        .ft {
            position:absolute; z-index:1; left:0; bottom:0; right:0; height:54px;
            .form-action {
                padding:5px 16px;
            }
        }
    }
    .tabbar-placeholder {
        height:54px;
    }
    .tabbar {
        position:fixed; left:0; bottom:0; right:0; height:72px; background:#fff; box-shadow:0 0 8px rgba(0,0,0,.08);
        .tabbar-inner {
            padding:5px 15px;
            .total {
                .total-title {font-size:14px; color:#666;}
                .total-val {
                    .num {font-size:18px; font-weight:600;}
                    .unit {font-size:16px; color:#666; margin-left:6px;}
                }
                .total-fee {
                    font-size:14px; color:#999;
                }
            }
            &.u-flex {
                display:flex; justify-content: space-between; align-items: center;
                .u-flex-item {
                    &:first-child {margin-right:7px;}
                    &:last-child {margin-left:8px;}
                }
                .u-flex-1 {
                    flex:1;
                }
                .u-flex-2 {
                    flex:2;
                }
                .u-flex-3 {
                    flex:3;
                }
            }
        }
    }
    .mint-dialog {
      .left-img {
        text-align: center;
        img {
          max-height: 300px;
        }
      }
      ul {
        li {
          display: flex;
          align-items: center;
          line-height: 40px;
          & > span {
            color: #000;
            font-weight: 600;
            margin-right: 5px;
          }
          img {
            width: 22px;
          }
        }
      }
      .mint-Confirm {
        text-align: center;
        margin-top: 10px;
        .el-button {
          background: #ffdda9;
          border: none;
          &:hover {
            border: none;
            color: #333;
            background: #fad398;
          }
        }
      }
    }
    </style>